<template>
  <div id="activity" class="maincont">
    <div class="ef--inner2 filter">

      <!--*************************************************************---
      <--- タブ(ヘッダー)
      <--*************************************************************-->
      <div id="tab_info" class="tab-info">
        <div id="tab_power" class="tab active" v-on:click="onTabClick('tab_power', 'block')">電力見える化アカウント</div>
        <div id="tab_es" class="tab inactive" v-on:click="onTabClick('tab_es', 'block')">ESアカウント</div>
      </div>

      <div id="page_info" class="page-info page-info-frame">

        <!--*************************************************************---
        <--- シングルアカウント一覧
        <--*************************************************************-->
        <div id="tab_power">
          <div class="block-info display-flex">
            <!--=============================================================---
            <--- 絞込
            <--=============================================================-->
            <div class="filter-info display-flex">
              <div class="header-info">条 件</div>

              <div class="line-info display-flex">
                <!------------------------------------------------------------------
                <-- でんき予報
                <------------------------------------------------------------------>
                <div class="item-info display-flex">
                  <label class="title">でんき予報</label>
                  <div class="body display-inline">
                    <select
                      class="small"
                      id="denki-yoho"
                      name="denki-yoho"
                      v-model="power_info.filter_info.electrical_forecast"
                    >
                      <option value="1" selected="selected">すべて</option>
                      <option value="2">良好</option>
                      <option value="3">安定</option>
                      <option value="4">やや厳しい</option>
                      <option value="5">厳しい</option>
                    </select>
                  </div>
                </div>

                <!------------------------------------------------------------------
                <-- 気温リスク
                <------------------------------------------------------------------>
                <div class="item-info display-flex">
                  <label class="title">気温リスク</label>
                  <div class="body display-inline">
                    <select
                      class="small"
                      id="kouon-risk"
                      name="kouon-risk"
                      v-model="power_info.filter_info.high_temperature_risk"
                    >
                      <option value="1" selected="selected">すべて</option>
                      <option value="2">30℃以上</option>
                      <option value="3">5℃以下</option>
                    </select>
                  </div>
                </div>

                <!------------------------------------------------------------------
                <-- 実績増加率
                <------------------------------------------------------------------>
                <div class="item-info display-flex">
                  <label class="title">実績増加率</label>
                  <div class="body display-inline">
                    <select
                      class="small"
                      id="jisseki-zoukaritsu"
                      name="jisseki-zoukaritsu"
                      v-model="power_info.filter_info.increase_rate"
                    >
                      <option value="1" selected="selected">すべて</option>
                      <option value="3">3％以上</option>
                      <option value="5">5％以上</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="footer-info display-flex">
                <input
                  type="button"
                  class="mini"
                  id="filter"
                  value="絞 込"
                  @click="onFilterPower()"
                />
              </div>
            </div>

            <!--=============================================================---
            <--- ダウンロード
            <--=============================================================-->
            <div class="func-info display-flex">
              <input
                type="button"
                class="small"
                id="download"
                value="表示データダウンロード"
                @click="onDownload()"
              />
            </div>
          </div>

          <!--=============================================================---
          <--- リスト(シングルアカウント一覧)
          <--=============================================================-->
          <div class="block-info display-block">
            <div class="list-info" style="height:610px;">
              <table class="list-table">
                <thead>
                  <tr>
                    <th rowspan="2" width="1%"></th>
                    <th rowspan="2"><a href="javascript:void(0);" @click="onSortPower('name')">お客さま名</a></th>
                    <th v-if="power_info.hasAirCon" rowspan="2" width="3%"><a href="javascript:void(0);" @click="onSortPower('air_conditioner_control')">空調機<br/>制御</a></th>
                    <th colspan="2">現状</th>
                    <th colspan="4">本日の実績</th>
                    <th colspan="2">翌日の予測</th>
                    <th v-if="power_info.hasAirCon" colspan="3">当月の実績</th>
                    <th v-else colspan="2">当月の実績</th>
                    <th v-if="power_info.hasAirCon" colspan="3">前月の実績</th>
                    <th v-else colspan="2">前月の実績</th>
                    <th rowspan="2" width="6%"><a href="javascript:void(0);" @click="onSortPower('increase_rate_year')">一昨年と<br/>昨年の<br/>増加割合</a></th>
                    <!-- <th rowspan="2" width="4%">最終更新</th> -->
                    <th rowspan="2" width="3%">詳細</th>
                  </tr>
                  <tr>
                    <th width="4%"><a href="javascript:void(0);" @click="onSortPower('control_status')">デマンド<br/>状態</a></th>
                    <th width="6%"><a href="javascript:void(0);" @click="onSortPower('contract_power')">デマンド<br/>目標値</a></th>
                    <th width="6%"><a href="javascript:void(0);" @click="onSortPower('electrical_forecast_today')">でんき予報</a></th>
                    <th width="3%"><a href="javascript:void(0);" @click="onSortPower('weather_forecast_today')">天気予報</a></th>
                    <th width="6%"><a href="javascript:void(0);" @click="onSortPower('max_demand_today')">最大デマンド</a></th>
                    <th width="4%"><a href="javascript:void(0);" @click="onSortPower('alert_count_today')">アラート<br/>回数</a></th>
                    <th width="6%"><a href="javascript:void(0);" @click="onSortPower('electrical_forecast_tomorrow')">でんき予報</a></th>
                    <th width="3%"><a href="javascript:void(0);" @click="onSortPower('weather_forecast_tomorrow')">天気予報</a></th>
                    <th width="6%"><a href="javascript:void(0);" @click="onSortPower('max_demand_month')">最大デマンド</a></th>
                    <th width="4%"><a href="javascript:void(0);" @click="onSortPower('alert_count_month')">アラート<br/>回数</a></th>
                    <th v-if="power_info.hasAirCon" width="6%"><a href="javascript:void(0);" @click="onSortPower('control_power_month')">制御効果量</a></th>
                    <th width="6%"><a href="javascript:void(0);" @click="onSortPower('power_usage_last_month')">電力使用量</a></th>
                    <th width="4%" class="border-right"><a href="javascript:void(0);" @click="onSortPower('increase_rate_last_month')">前年と<br/>増加割合</a></th>
                    <th v-if="power_info.hasAirCon" width="6%"><a href="javascript:void(0);" @click="onSortPower('control_power_last_month')">制御効果量</a></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in power_info.filter_activities" v-bind:key="index">
                    <!------------------------------------------------------------------
                    <-- No
                    <------------------------------------------------------------------>
                    <td style="text-align:right;">{{ index + 1 }}</td>

                    <!------------------------------------------------------------------
                    <-- お客さま名
                    <------------------------------------------------------------------>
                    <td>{{ item.name }}</td>

                    <!------------------------------------------------------------------
                    <-- 空調機制御
                    <------------------------------------------------------------------>
                    <td v-if="power_info.hasAirCon" style="text-align:center;">
                      <label
                        v-bind:class="getSettingStatus(item.air_conditioner_control).color"
                      >
                        {{ getSettingStatus(item.air_conditioner_control).msg }}
                      </label>
                    </td>

                    <!------------------------------------------------------------------
                    <-- (現状)デマンド状態
                    <------------------------------------------------------------------>
                    <td style="text-align:center;">
                      <label
                        v-bind:class="getDemandStatus(item.air_conditioner_control, item.control_status).back"
                      >
                        {{ getDemandStatus(item.air_conditioner_control, item.control_status).msg }}
                      </label>
                    </td>

                    <!------------------------------------------------------------------
                    <-- (現状)デマンド目標値
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span>{{ numComma(item.contract_power) }}</span> kW</td>

                    <!------------------------------------------------------------------
                    <-- (本日の実績)でんき予報
                    <------------------------------------------------------------------>
                    <td style="text-align:center;" v-if="getForecastLevel(item.electrical_forecast_today) == ''" v-bind:class="getForecastLevel(item.electrical_forecast_today)">
                      {{ getForecastString(item.electrical_forecast_today) }}
                      <br>
                    </td>
                    <td style="text-align:center;" v-else v-bind:class="getForecastLevel(item.electrical_forecast_today)">
                      {{ getForecastString(item.electrical_forecast_today) }}
                      <br>
                      <span>{{ numComma(item.electrical_forecast_today_power) }}</span> kW
                    </td>

                    <!------------------------------------------------------------------
                    <-- (本日の実績)天気予報
                    <------------------------------------------------------------------>
                    <td style="text-align:center;"><img v-bind:src="getWeatherIconUrl(item.weather_forecast_today)" /></td>

                    <!------------------------------------------------------------------
                    <-- (本日の実績)最大デマンド
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span v-bind:class="getDemandLevel(item.max_demand_today, item.contract_power)">{{ numComma(item.max_demand_today) }}</span> kW</td>

                    <!------------------------------------------------------------------
                    <-- (本日の実績)アラート回数
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span>{{ numComma(item.alert_count_today) }}</span> 回</td>

                    <!------------------------------------------------------------------
                    <-- (翌日の予測)でんき予報
                    <------------------------------------------------------------------>
                    <td style="text-align:center;" v-if="getForecastLevel(item.electrical_forecast_tomorrow) == ''" v-bind:class="getForecastLevel(item.electrical_forecast_tomorrow)">
                      {{ getForecastString(item.electrical_forecast_tomorrow) }}
                    </td>
                    <td style="text-align:center;" v-else v-bind:class="getForecastLevel(item.electrical_forecast_tomorrow)">
                      {{ getForecastString(item.electrical_forecast_tomorrow) }}
                      <br>
                      <span>{{ numComma(item.electrical_forecast_tomorrow_power) }}</span> kW
                    </td>

                    <!------------------------------------------------------------------
                    <-- (翌日の予測)天気予報
                    <------------------------------------------------------------------>
                    <td style="text-align:center;"><img v-bind:src="getWeatherIconUrl(item.weather_forecast_tomorrow)" /></td>

                    <!------------------------------------------------------------------
                    <-- (当月の実績)最大デマンド
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span v-bind:class="getDemandLevel(item.max_demand_month, item.contract_power)">{{ numComma(item.max_demand_month) }}</span> kW</td>

                    <!------------------------------------------------------------------
                    <-- (当月の実績)累積アラート回数
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span>{{ numComma(item.alert_count_month) }}</span> 回</td>

                    <!------------------------------------------------------------------
                    <-- (当月の実績)制御効果量
                    <------------------------------------------------------------------>
                    <td v-if="power_info.hasAirCon" style="text-align:right;"><span>{{ numComma(item.control_power_month) }}</span> kWh</td>

                    <!------------------------------------------------------------------
                    <-- (前月の実績)電力使用量
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span>{{ numComma(item.power_usage_last_month) }}</span> MWh</td>

                    <!------------------------------------------------------------------
                    <-- (前月の実績)前年と増加割合
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span v-bind:class="getIncreaseRateLevel(item.increase_rate_last_month)">{{ numComma(item.increase_rate_last_month) }}</span> ％</td>

                    <!------------------------------------------------------------------
                    <-- (前月の実績)制御効果量
                    <------------------------------------------------------------------>
                    <td v-if="power_info.hasAirCon" style="text-align:right;"><span>{{ numComma(item.control_power_last_month) }}</span> kWh</td>

                    <!------------------------------------------------------------------
                    <-- 一昨年と昨年の増加割合
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span v-bind:class="getIncreaseRateLevel(item.increase_rate_year)">{{ numComma(item.increase_rate_year) }}</span> ％</td>

                    <!------------------------------------------------------------------
                    <-- 最終更新
                    <------------------------------------------------------------------>
                    <!-- <td style="text-align:right;">{{ item.last_update }} 分前</td> -->

                    <!------------------------------------------------------------------
                    <-- 詳細
                    <------------------------------------------------------------------>
                    <td style="text-align:center;">
                      <a href="javascript:void(0);" @click="onDetail(item.account)">
                        <img src="/assets/images/activity/icon.detail.png" />
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!--*************************************************************---
        <--- ESアカウント一覧
        <--*************************************************************-->
        <div id="tab_es" style="display:none">
          <!--=============================================================---
          <--- 絞込
          <--=============================================================-->
          <div class="block-info display-block">
            <div class="filter-info display-flex">
              <div class="header-info">条 件</div>

              <div class="line-info display-flex">
                <!------------------------------------------------------------------
                <-- アカウントNo.
                <------------------------------------------------------------------>
                <div class="item-info display-flex">
                  <label class="title" for="account">アカウントNo.</label>
                  <div class="body display-inline">
                    <input
                      type="text"
                      class="small"
                      v-model="es_info.filter_info.account"
                    />
                  </div>
                </div>

                <!------------------------------------------------------------------
                <-- お客さま名
                <------------------------------------------------------------------>
                <div class="item-info display-flex">
                  <label class="title" for="company_name">お客さま名</label>
                  <div class="body display-inline">
                    <input
                      type="text"
                      class="normal"
                      v-model="es_info.filter_info.company_name"
                    />
                  </div>
                </div>

                <!------------------------------------------------------------------
                <-- 支店
                <------------------------------------------------------------------>
                <div class="item-info display-flex">
                  <label class="title" for="sales_center_id">支店</label>
                  <div class="body display-inline">
                    <select
                      class="small"
                      id="eigyo-center"
                      name="eigyo-center"
                      v-model="es_info.filter_info.sales_center_id"
                    >
                      <option value = ""></option>
                      <option
                        v-for="(option, index) in $store.state.salesCenterMaster"
                        v-bind:value="option.sales_center_id"
                        v-bind:key="index"
                      >{{ option.sales_center_name }}</option>
                    </select>
                  </div>
                </div>

                <!------------------------------------------------------------------
                <-- 営業所
                <------------------------------------------------------------------>
                <div class="item-info display-flex">
                  <label class="title" for="sales_office_id">営業所</label>
                  <div class="body display-inline">
                    <select
                      class="small"
                      id="eigyosho"
                      name="eigyosho"
                      v-model="es_info.filter_info.sales_office_id"
                    >
                      <option value = ""></option>
                      <option
                        v-for="(option, index) in es_info.filter_info.sales_office_ids"
                        v-bind:value="option.sales_office_id"
                        v-bind:key="index"
                      >{{ option.sales_office_name }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="footer-info display-flex">
                <input
                  type="button"
                  class="mini"
                  id="filter"
                  value="絞 込"
                  @click="onFilterEs()"
                />
              </div>
            </div>
          </div>

          <!--=============================================================---
          <--- リスト(シングルアカウント(ES))
          <--=============================================================-->
          <div class="block-info display-block">
            <div class="list-info" style="height:610px;">
              <table class="list-table">
                <thead>
                  <tr>
                    <th rowspan="2" width="7%"><a href="javascript:void(0);" @click="onSortEs('account')">アカウントNo.</a></th>
                    <th rowspan="2" ><a href="javascript:void(0);" @click="onSortEs('name', 'name')">お客さま名</a></th>
                    <th colspan="2">発生中警報</th>
                    <th colspan="4">設備一覧</th>
                  </tr>
                  <tr>
                    <th width="4%"><a href="javascript:void(0);" @click="onSortEs('alert_info.binary_minor')">軽故障</a></th>
                    <th width="4%"><a href="javascript:void(0);" @click="onSortEs('alert_info.binary_major')">重故障</a></th>
                    <th width="3%"><a href="javascript:void(0);" @click="onSortEs('device_info.aircon.using')">空調</a></th>
                    <th width="3%"><a href="javascript:void(0);" @click="onSortEs('device_info.receiver.using')">受変電</a></th>
                    <th width="3%"><a href="javascript:void(0);" @click="onSortEs('device_info.generator.using')">発電</a></th>
                    <th width="3%">その他</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in es_info.filter_activities" v-bind:key="index">
                    <!------------------------------------------------------------------
                    <-- アカウントNo
                    <------------------------------------------------------------------>
                    <td>{{ item.account }}</td>

                    <!------------------------------------------------------------------
                    <-- お客さま名
                    <------------------------------------------------------------------>
                    <td>
                      <p v-if="item.parent_name == '' || item.parent_name == null">{{ item.name }} さま</p>
                      <p v-else>[ {{ item.parent_name }} ]<br>{{ item.name }} さま</p>
                    </td>

                    <!------------------------------------------------------------------
                    <-- (発生中警報)軽故障
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span>{{ numComma(item.alert_info.binary_minor) }}</span> 件</td>

                    <!------------------------------------------------------------------
                    <-- (発生中警報)重故障
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span>{{ numComma(item.alert_info.binary_major) }}</span> 件</td>

                    <!------------------------------------------------------------------
                    <-- (設備一覧)空調
                    <------------------------------------------------------------------>
                    <td
                      v-bind:class="getAlertNotify(item.device_info.aircon.alert_count)"
                      style="text-align:center;"
                    >
                      <a
                        href="javascript:void(0);"
                        @click="onDetailDevice(item.account, item.device_info.aircon.using, 1)"
                      >
                        <img v-bind:src="getDeviceAirConditionerIconUrl(item.device_info.aircon.using)" />
                      </a>
                    </td>

                    <!------------------------------------------------------------------
                    <-- (設備一覧)受変電
                    <------------------------------------------------------------------>
                    <td
                      v-bind:class="getAlertNotify(item.device_info.receiver.alert_count)"
                      style="text-align:center;"
                    >
                      <a
                        href="javascript:void(0);"
                        @click="onDetailDevice(item.account, item.device_info.receiver.using, 2)"
                      >
                        <img v-bind:src="getDeviceReceiverIconUrl(item.device_info.receiver.using)" />
                      </a>
                    </td>

                    <!------------------------------------------------------------------
                    <-- (設備一覧)発電
                    <------------------------------------------------------------------>
                    <td
                      v-bind:class="getAlertNotify(item.device_info.generator.alert_count)"
                      style="text-align:center;"
                    >
                      <a
                        href="javascript:void(0);"
                        @click="onDetailDevice(item.account, item.device_info.generator.using, 4)"
                      >
                        <img v-bind:src="getDeviceGeneratorIconUrl(item.device_info.generator.using)" />
                      </a>
                    </td>

                    <!------------------------------------------------------------------
                    <-- (設備一覧)その他
                    <------------------------------------------------------------------>
                    <td style="text-align:center;">
                      <img v-bind:src="getDeviceElectricIconUrl()" />
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>
    <LoadExternalJS :url="fixedMidashiUrl"></LoadExternalJS>
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import Store from "../../store";
import Utils from "../../utils/utils";
import moment from "moment";
import LoadExternalJS from "../../components/LoadExternalJS";

export default {
  name: "shop_list",
  components: {
    LoadExternalJS
  },
  data: function() {
    return {
      power_info: {
        activities: [],
        filter_activities: [],
        filter_info: {
          electrical_forecast: 1,
          high_temperature_risk: 1,
          increase_rate: 1
        },
        sort_info: {
          sort_type: "",
          sort_order: 0
        },
        hasAirCon: false
      },
      es_info: {
        activities: [],
        filter_activities: [],
        filter_info: {
          parent_name: "",
          account: "",
          company_name: "",
          sales_center_id: 0,
          sales_office_id: 0,
          sales_office_ids: []
        },
        sort_info: {
          sort_type: "",
          sort_order: 0
        }
      },
      fixedMidashiUrl: "./assets/js/fixed_midashi.js"
    };
  },

  watch: {
    'es_info.filter_info.sales_center_id': function(newValue, oldValue) {
      console.log("es_info.filter_info.sales_center_id");
      console.log("newValue:" + newValue + ", oldValue" + oldValue);

      let office = this.$store.state.salesOfficeMaster.filter(
        obj => obj.sales_center_id == newValue
      );
      this.es_info.filter_info.sales_office_id = 0;
      this.es_info.filter_info.sales_office_ids = office;
    }
  },

  updated: function() {
    window.FixedMidashi.remove();
    window.FixedMidashi.create();
  },

  created: function() {
    console.log("created");
    this.$axios
      .get(`/srv/api/chain_list/${Store.state.parentID}`, {
        withCredentials: true
      })
      .then(response => {
        console.log("chain_list success");
        console.log(response.data);
        if (typeof response.data == "object") {
          this.power_info.activities = response.data.store_list;
          this.power_info.filter_activities = response.data.store_list;
          this.power_info.hasAirCon = response.data.has_air_con;
        } else {
          // stinrgのときはセッションタイムアウト
          alert("sesssion time out");
          this.$store.dispatch("logout");
          this.$router.push("/login");
        }
      })
      .catch(error => {
        console.log("chain_list error");
        console.log(error);
      });
    this.$axios
    .get(`/srv/api/activity_list_es/${Store.state.parentID}`, {
      withCredentials: true
    })
    .then(response => {
      console.log("success");
      console.log(response.data);
      if (typeof response.data == "object") {
        this.es_info.activities = response.data.activityEsList;
        this.es_info.filter_activities = response.data.activityEsList;
        // Store.dispatch(
        //   "setActivityList",
        //   response.data["activity"]
        // );
        // //this.$store.dispatch("activityPageReset", self.activities.length);
      } else {
        // stinrgのときはセッションタイムアウト
        alert("sesssion time out");
        this.$store.dispatch("logout");
        this.$router.push("/login");
      }
    })
    .catch(error => {
      console.log("chain_list_es error");
      console.log(error);
    });
  },

  methods: {
    getMonth: function(value) {
      if (value == null || value == "") {
        return "";
      } else {
        return moment.utc(value, "YYYY/MM/DD HH:mm:ss").format("MM月");
      }
    },
    getDay: function(value) {
      if (value == null || value == "") {
        return "";
      } else {
        return moment.utc(value, "YYYY/MM/DD HH:mm:ss").format("DD日");
      }
    },
    getTime: function(value) {
      if (value == null || value == "") {
        return "";
      } else {
        return moment.utc(value, "YYYY/MM/DD HH:mm:ss").format("HH:mm");
      }
    },

    onFilterPower: function() {
      console.log("onFilterPower");
      console.log(
        "electrical_forecast:" + this.power_info.filter_info.electrical_forecast + ", " +
        "high_temperature_risk:" + this.power_info.filter_info.high_temperature_risk + ", " +
        "increase_rate:" + this.power_info.filter_info.increase_rate
      );

      this.power_info.filter_activities = this.power_info.activities;

      if (this.power_info.filter_info.electrical_forecast != 1) {
        const list = this.power_info.filter_activities.filter(
          obj => obj.electrical_forecast_today == (this.power_info.filter_info.electrical_forecast - 2)
        );
        this.power_info.filter_activities = list;
      }

      if (this.power_info.filter_info.high_temperature_risk == 2) {
        const list = this.power_info.filter_activities.filter(
          obj => obj.temperature_today >= 30
        );
        this.power_info.filter_activities = list;
      }

      if (this.power_info.filter_info.high_temperature_risk == 3) {
        const list = this.power_info.filter_activities.filter(
          obj => obj.temperature_today <= 5
        );
        this.power_info.filter_activities = list;
      }

      if (this.power_info.filter_info.increase_rate != 1) {
        const list = this.power_info.filter_activities.filter(
          obj => parseFloat(obj.increase_rate_last_month) >= this.power_info.filter_info.increase_rate
        );
        this.power_info.filter_activities = list;
      }
    },

    onFilterEs: function() {
      console.log("onFilterEs");
      console.log(
        "parent_name:" + this.es_info.filter_info.parent_name + ", " +
        "account:" + this.es_info.filter_info.account + ", " +
        "company_name:" + this.es_info.filter_info.company_name + ", " +
        "sales_center_id:" + this.es_info.filter_info.sales_center_id + ", " +
        "sales_office_id:" + this.es_info.filter_info.sales_office_id
      );

      this.es_info.filter_activities = this.es_info.activities;

      if (this.es_info.filter_info.parent_name) {
        const list = this.es_info.filter_activities.filter(
          item => (
                    ((item.parent_name != null) && (item.parent_name.indexOf(this.es_info.filter_info.parent_name) > -1))
                  )
        );
        this.es_info.filter_activities = list;
      }

      if (this.es_info.filter_info.account) {
        const list = this.es_info.filter_activities.filter(
          item => (
                    ((item.account != null) && (item.account.indexOf(this.es_info.filter_info.account) > -1))
                  )
        );
        this.es_info.filter_activities = list;
      }

      if (this.es_info.filter_info.company_name) {
        const list = this.es_info.filter_activities.filter(
          item => (
                    ((item.name != null) && (item.name.indexOf(this.es_info.filter_info.company_name) > -1))
                  )
        );
        this.es_info.filter_activities = list;
      }

      if (this.es_info.filter_info.sales_center_id) {
        const list = this.es_info.filter_activities.filter(
          obj => obj.sales_center_id == this.es_info.filter_info.sales_center_id
        );
        this.es_info.filter_activities = list;
      }

      if (this.es_info.filter_info.sales_office_id) {
        const list = this.es_info.filter_activities.filter(
          obj => obj.sales_office_id == this.es_info.filter_info.sales_office_id
        );
        this.es_info.filter_activities = list;
      }
    },

    onSortPower: function(type) {
      console.log("onSortPower");

      let sortOrder = 0;

      if (this.power_info.sort_info.sort_type == type) {
        this.power_info.sort_info.sort_order = (this.power_info.sort_info.sort_order === 1) ? 0 : 1;
      } else {
        this.power_info.sort_info.sort_order = 0;
      }
      this.power_info.sort_info.sort_type = type;
      sortOrder = this.power_info.sort_info.sort_order;

      if (type == "control_status") {
        this.power_info.filter_activities.sort(function(a, b) {
          let data1 = eval(`a.${type}`);
          let data2 = eval(`b.${type}`);
          if (a['air_conditioner_control'] == true) {
            data1 += (data1 == 1 ? 2 : 0)
            data1 += 10;
          }
          if (b['air_conditioner_control'] == true) {
            data2 += (data2 == 1 ? 2 : 0)
            data2 += 10;
          }
          if (sortOrder == 0) {
            return (data1 < data2) ? -1 : (data1 > data2) ? 1 : 0;
          } else {
            return (data1 < data2) ? 1 : (data1 > data2) ? -1 : 0;
          }
        });
      } else {
        this.power_info.filter_activities.sort(function(a, b) {
          let data1 = eval(`a.${type}`);
          let data2 = eval(`b.${type}`);
          if (sortOrder == 0) {
            return (data1 < data2) ? -1 : (data1 > data2) ? 1 : 0;
          } else {
            return (data1 < data2) ? 1 : (data1 > data2) ? -1 : 0;
          }
        });
      }
    },

    onSortEs: function(type) {
      console.log("onSortEs");

      let sortOrder = 0;

      if (this.es_info.sort_info.sort_type == type) {
        this.es_info.sort_info.sort_order = (this.es_info.sort_info.sort_order === 1) ? 0 : 1;
      } else {
        this.es_info.sort_info.sort_order = 0;
      }
      this.es_info.sort_info.sort_type = type;
      sortOrder = this.es_info.sort_info.sort_order;

      this.es_info.filter_activities.sort(function(a, b) {
        let data1 = eval(`a.${type}`);
        let data2 = eval(`b.${type}`);
        if (sortOrder == 0) {
          return (data1 < data2) ? -1 : (data1 > data2) ? 1 : 0;
        } else {
          return (data1 < data2) ? 1 : (data1 > data2) ? -1 : 0;
        }
      });
    },

    onDetail: function(account) {
      console.log(account);
      this.$store.dispatch("setConfirm", { isConfirmed: true });
      this.$store.dispatch("setChildID", account);
      let route = this.$router.resolve({path: '/'});
      window.open(route.href, '_blank');
    },

    onDetailDevice: function(account, using, selectedDevice) {
      if (using) {
        this.$store.dispatch("setConfirm", { isConfirmed: true });
        this.$store.dispatch("setChildID", account);
        this.$store.dispatch("setSelectedDevice", selectedDevice);
        let route = this.$router.resolve({path: '/es/system_diagram_display'});
        window.open(route.href, '_blank');
      }
    },

    onTabClick: function(tab_name) {
      var tab;
      var tab_item;
      var children;

      tab = document.getElementById('tab_info');
      children = tab.children;
      for(let i = 0; i < children.length; i++) {
        if (children[i].id == tab_name) {
          children[i].className = "tab active";
        } else {
          children[i].className = "tab inactive";
        }
      }

      tab_item = document.getElementById('page_info');
      children = tab_item.children;
      for(let i = 0; i < children.length; i++) {
        if (children[i].id == tab_name) {
          children[i].style.display = "block";
        } else {
          children[i].style.display = "none";
        }
      }
    },

    onDownload: function() {
      console.log("onDownload");
      console.log(
        "electrical_forecast:" + this.power_info.filter_info.electrical_forecast + ", " +
        "high_temperature_risk:" + this.power_info.filter_info.high_temperature_risk + ", " +
        "increase_rate:" + this.power_info.filter_info.increase_rate
      );

      const param = {
        electrical_forecast: this.power_info.filter_info.electrical_forecast,
        temperature_risk: this.power_info.filter_info.high_temperature_risk,
        increase_rate: this.power_info.filter_info.increase_rate,
        store_list: this.power_info.activities,
        has_air_con: this.power_info.hasAirCon
      };

      this.$axios
        .post(`/srv/api/store_results_file/${Store.state.parentID}`, param, {
          withCredentials: true,
          responseType: "blob",
          exposedHeaders: ["Content-Disposition"]
        })
        .then(response => {
          console.log(response);
          console.log(response.headers["content-disposition"]);
          let fileName = "";
          const contentDisposition = response.headers["content-disposition"];
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(contentDisposition);
          if (matches != null && matches[1]) {
            fileName = matches[1].replace(/['"]/g, "");
          }
          console.log(fileName);

          if (
            response.headers["content-type"].indexOf("application/json") != -1
          ) {
            alert("ダウンロードできませんでした");
            return;
          }
          const dl = document.getElementById("downloadLink");
          if (dl != undefined) dl.parentNode.removeChild(dl);

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("id", "downloadLink");
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          this.$emit("close");
        })
        .catch(error => {
          // ...
          console.log(error);
        });
    }
  }
};
</script>
